import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import NoDataComponent from "@helpers/NoDataComponent";
import { ChevronDown } from "lucide-react";

const ExpandableSection = ({
  identifier,
  title,
  data,
  allowedKeys,
  displayValues,
  customValues,
  expanded,
  onToggle,
}) => {
  return (
    <div className="section mt-10 pb-10 px-5 border-b-2 border-gray-200">
      <div
        className={`title dark:text-white flex gap-2 items-center cursor-pointer font-bold text-lg`}
        onClick={onToggle}
      >
        {title}
        <ChevronDown
          className={clsx(
            !expanded && "rotate-180",
            `size-5 transition-all duration-500 dark:text-white`
          )}
        />
      </div>
      <div
        className={clsx(
          `content px-5 grid grid-rows-[0fr] transition-all ease-in-out duration-500`,
          expanded ? "  opacity-100 grid-rows-[1fr] mt-10" : "opacity-0 mt-0"
        )}
      >
        <div
          className={clsx(`overflow-hidden grid`, data && "grid-cols-3 gap-6")}
        >
          {!!data ? (
            allowedKeys
              .filter((key) => Object.prototype.hasOwnProperty.call(data, key))
              .map((key, index) => (
                <div
                  key={index}
                  className="info dark:text-white flex flex-col gap-3 items-start"
                >
                  <div className="key font-semibold">
                    {displayValues[key] || key}
                  </div>
                  <div className="value">
                    {!!customValues[key] ? customValues[key] : data[key]}
                  </div>
                </div>
              ))
          ) : (
            <NoDataComponent />
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpandableSection;
